import { useCallback, useMemo, useRef, useState } from 'react';
export default function useSplitPaneSizes(opts) {
  const {
    dataViewerId,
    overrideModel,
    overrides
  } = opts;
  const debounceRef = useRef();
  const [sizes, setSizes] = useState(overrideModel?.splitPaneSizes || ['auto', 400]);
  const onChangeSizes = useCallback(value => {
    setSizes(value);
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      overrides.set(dataViewerId, 'splitPaneSizes', value);
    }, 500);
  }, [dataViewerId, overrides]);
  return useMemo(() => {
    return {
      sizes,
      onChangeSizes
    };
  }, [sizes, onChangeSizes]);
}